import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import { Button } from "../components/ui/button";
import {
  Users as UsersIcon,
  ShoppingCart,
  DollarSign,
  TrendingUp,
  BarChart3,
  Package,
} from "lucide-react";

export const Dashboard: React.FC = () => {
  const navigate = useNavigate();

  const stats = [
    {
      title: "총 사용자",
      value: "2,350",
      change: "+20.1%",
      changeType: "positive" as const,
      icon: UsersIcon,
    },
    {
      title: "총 주문",
      value: "1,234",
      change: "+15.3%",
      changeType: "positive" as const,
      icon: ShoppingCart,
    },
    {
      title: "총 매출",
      value: "₩45,231,000",
      change: "+12.5%",
      changeType: "positive" as const,
      icon: DollarSign,
    },
    {
      title: "전환율",
      value: "3.2%",
      change: "-2.1%",
      changeType: "negative" as const,
      icon: TrendingUp,
    },
  ];

  const recentActivities = [
    {
      id: 1,
      action: "새 사용자가 가입했습니다",
      time: "2분 전",
      user: "김철수",
    },
    { id: 2, action: "주문이 완료되었습니다", time: "5분 전", user: "이영희" },
    { id: 3, action: "결제가 처리되었습니다", time: "10분 전", user: "박민수" },
    { id: 4, action: "상품이 추가되었습니다", time: "15분 전", user: "정수진" },
    { id: 5, action: "리뷰가 작성되었습니다", time: "20분 전", user: "최지영" },
  ];

  return (
    <div className="space-y-6">
      {/* 통계 카드 */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat) => (
          <Card key={stat.title}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium text-muted-foreground">
                {stat.title}
              </CardTitle>
              <stat.icon className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{stat.value}</div>
              <p
                className={`text-xs ${
                  stat.changeType === "positive"
                    ? "text-green-600"
                    : "text-red-600"
                }`}
              >
                {stat.change} 지난 달 대비
              </p>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* 차트 및 활동 섹션 */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* 매출 차트 */}
        <Card>
          <CardHeader>
            <CardTitle>매출 현황</CardTitle>
            <CardDescription>최근 7일간의 매출 추이</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="h-[300px] flex items-center justify-center bg-gray-50 rounded-lg">
              <div className="text-center">
                <BarChart3 className="h-12 w-12 text-gray-400 mx-auto mb-4" />
                <p className="text-gray-500">차트 데이터가 여기에 표시됩니다</p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* 최근 활동 */}
        <Card>
          <CardHeader>
            <CardTitle>최근 활동</CardTitle>
            <CardDescription>실시간 시스템 활동 내역</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {recentActivities.map((activity) => (
                <div key={activity.id} className="flex items-center space-x-4">
                  <div className="h-2 w-2 bg-primary rounded-full"></div>
                  <div className="flex-1 space-y-1">
                    <p className="text-sm font-medium">{activity.action}</p>
                    <p className="text-xs text-muted-foreground">
                      {activity.user} • {activity.time}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>

      {/* 빠른 액션 */}
      <Card>
        <CardHeader>
          <CardTitle>빠른 액션</CardTitle>
          <CardDescription>자주 사용하는 관리 기능들</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Button
              className="h-20 flex flex-col space-y-2"
              onClick={() => navigate("/product-register")}
            >
              <Package className="h-6 w-6" />
              <span>상품 등록</span>
            </Button>
            <Button variant="outline" className="h-20 flex flex-col space-y-2">
              <UsersIcon className="h-6 w-6" />
              <span>사용자 관리</span>
            </Button>
            <Button variant="outline" className="h-20 flex flex-col space-y-2">
              <ShoppingCart className="h-6 w-6" />
              <span>주문 관리</span>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
